import React, { useRef } from 'react'
import { motion } from 'framer-motion'

import { Container } from '../../Container'
import ContentfulLongText from '../../ContentfulLongText'
import { Action } from '../Action'
import { YouTubePlayer } from '../../GlobalComponent'

import './text-image.css'

export const TextImage = ({ heroContent, pageHeroTitle, isAlignCenter }) => {
  const ref = useRef(null);
  const videoId = heroContent.backgroundVideo
    ? heroContent.backgroundVideo.match(/(?:\/|%2F)([A-Za-z0-9_-]{11})/)[1]
    : '';

  const isAlignCenterClass = isAlignCenter ? ' align-center':''

  return (
    <div ref={ref} className={`relative cover no-repeat pages-hero pages-hero--customized text-image ${heroContent.backgroundVideo && 'overlay'}`} style={{
      backgroundImage: `url(${heroContent.backgroundMedia.gatsbyImageData.images.fallback.src})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
    }}>
      {videoId && <YouTubePlayer videoId={videoId} />}
      <Container>
        <div className={`grid col-5-6 col-1-md gap-15-md gap-49${isAlignCenterClass}`} style={{ paddingTop: heroContent.containerTopSpacing }}>
          <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1 }} className='image' style={{ textAlign: heroContent.position }}>
            {heroContent.image && <img src={heroContent.image} alt={heroContent.pageTitle || 'Text Media'} style={{ width: heroContent.imageCustomizeSize ? `${heroContent.imageCustomizeSize}px` : '' }} />}
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 100 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1 }} className='content'>
            {isAlignCenter ? (<img src={'https://images.ctfassets.net/vhts96p7twn6/7spobp8qEVmY1lkeCtoAJS/ecab925e215b08f326a66306254867b7/AST-Logo.png'} alt={pageHeroTitle} />):(<h1><span>{pageHeroTitle}</span></h1>)}
            <ContentfulLongText longTextContent={heroContent.content.content}/>
            <Action hasButtonConfiguration={!!heroContent.buttonConfig} actionData={heroContent.buttonConfig} />
          </motion.div>
        </div>
      </Container>
    </div>
  );
};